import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useAuth } from 'context/auth';
import clsx from 'clsx';
import styles from './styles.module.css';
import { Icon } from 'common/icon';
import { LoginModal } from 'components/modal/login';
import { useRouter } from 'next/router';
import { useLoginModal } from 'hooks';
import { useMeQuery } from 'hooks/api/users';
import { Analytics } from 'constants/analytics';
import { Avatar } from 'components/template/publication/comment';

export const AuthMenu = () => {
  const router = useRouter();
  const [isMounted, setIsMounted] = useState(false);
  const { isLoggedIn } = useAuth();
  const { data: me } = useMeQuery({ isSafe: false }, { skip: !isMounted });
  const { user } = me ?? {};
  const showLoggedIn = isMounted && isLoggedIn;
  const { handleCloseLoginModal, handleConfirmLoginModal, isLoginVisible } =
    useLoginModal();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleProfile = useCallback(() => {
    if (showLoggedIn) {
      router.push('/profile');
    } else {
      router.push('/login');
    }
  }, [showLoggedIn, router]);

  const dynamicClassContainer = useMemo(() => {
    if (showLoggedIn) {
      return styles.loggedIn;
    }
    return styles.unloggedIn;
  }, [showLoggedIn]);
  return (
    <nav
      className={clsx(styles.authNavigation, dynamicClassContainer)}
      suppressHydrationWarning
    >
      <div
        className={styles.loginButton}
        id={Analytics.general.headerLogin}
        onClick={handleProfile}
      >
        <div className={styles.user}>
          {showLoggedIn ? (
            <Avatar
              src={user?.imageUrl || ''}
              alt={'user sidebarmenu'}
              width={40}
              height={40}
            />
          ) : (
            <Icon.User width="25px" height="25px" />
          )}
          <div
            className={clsx({
              [styles.unLogged]: !showLoggedIn,
            })}
          >
            <span
              suppressHydrationWarning={true}
              className={clsx({
                [styles.login_text_unloggedIn]: !showLoggedIn,
                [styles.login_text_loggedIn]: showLoggedIn,
              })}
            >
              {showLoggedIn ? 'My Profile' : 'Log In'}
            </span>
          </div>
        </div>
        {showLoggedIn && (
          <div className={styles.arrow}>
            <Icon.Arrow width={25} height={25} fillOpacity={'0.4'} />
          </div>
        )}
        <LoginModal
          isVisible={isLoginVisible}
          onClose={handleCloseLoginModal}
          confirmOnClick={handleConfirmLoginModal}
        />
      </div>
    </nav>
  );
};
